export const DEVICE_MODEL = {
  A3700: 'A3700',
  A6630: 'A6630',
  A800: 'A800',
  A77: 'A77',
  A920: 'A920',
  A930: 'A930',
  E700: 'E700',
  ELO: 'ELO',
  L1400: 'L1400',
  Q20: 'Q20',
  Q25: 'Q25',
  WEB: 'web',
}

export const HANDHELD_DEVICES = [DEVICE_MODEL.A800, DEVICE_MODEL.A930, DEVICE_MODEL.A920, DEVICE_MODEL.A6630]

// CFD-Specific Hardware List
export const CFD_HARDWARE = [DEVICE_MODEL.A3700]

// Resource Restraint Hardware List
export const RESOURCE_RESTRAINED_HARDWARE = [DEVICE_MODEL.E700, DEVICE_MODEL.A930, DEVICE_MODEL.A920, DEVICE_MODEL.A77]
